import _export from '../internals/export.js';
import global$1 from '../internals/global.js';

var $ = _export;
var global = global$1; // `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis

$({
  global: true
}, {
  globalThis: global
});
